<template>
  <div>
    <div class="chart-wrapper">
      <div class="chart-switch">
        <span class="switch-label" :class="{ active: selectedMetric === 'MXP' }">MXP</span>
        <button
          class="switch-pill"
          @click="
            selectedMetric = selectedMetric === 'MXP' ? 'Calories' : 'MXP'
          "
        >
          <div
            class="switch-handle"
            :class="{ active: selectedMetric === 'Calories' }"
          ></div>
        </button>
        <span class="switch-label" :class="{ active: selectedMetric === 'Calories' }">Calories</span>
      </div>
      <div class="chart-container">
        <canvas ref="chart"></canvas>
      </div>
    </div>

    <div class="metrics-wrapper">
      <div class="workout-name" style="margin-top: 16px; margin-bottom: 16px">
        Workout Metrics
      </div>
      <div class="metrics-container">
        <div class="mxp-container">
          <div>
            <span class="mxp-label"
              ><img
                :src="require('@/assets/mxp_icon.svg')"
                alt=""
                srcset=""
                style="width: 50px; height: 16px"
              />
            </span>
            <br />Total: <br /><span class="mxp-value">{{ getMXP(item) }}</span>
          </div>
          <div style="display: flex; flex-direction: row; gap: 16px">
            <div>
              Left: <br /><span class="gray-value">{{
                getMXPBySide(item, "L")
              }}</span>
            </div>
            <div>
              Right: <br /><span class="gray-value">{{
                getMXPBySide(item, "R")
              }}</span>
            </div>
          </div>
        </div>

        <div class="mxp-container">
          <div>
            <span class="mxp-label">Reps</span> <br />Total: <br /><span
              class="mxp-value"
              >{{ getReps(item) }}</span
            >
          </div>
          <div style="display: flex; flex-direction: row; gap: 16px">
            <div>
              Left: <br /><span class="gray-value">{{
                getRepsBySide(item, "L")
              }}</span>
            </div>
            <div>
              Right: <br /><span class="gray-value">{{
                getRepsBySide(item, "R")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mxp-container" style="margin-top: 16px">
        <div style="display: flex; flex-direction: row; gap: 16px">
          <div style="flex: 1">
            <div class="metric-item">
              <img
                :src="require('@/assets/time_orange.svg')"
                alt=""
                srcset=""
                style="width: 18px; height: 18px; margin-right: 8px"
              />
              <span class="gray-value">{{ getTotalTime(item) }}</span
              >&nbsp;min
            </div>
            <div class="metric-item" style="margin-top: 8px">
              <img
                :src="require('@/assets/distance_orange.svg')"
                alt=""
                srcset=""
                style="
                  width: 24px;
                  height: 24px;
                  margin-right: 4px;
                  margin-left: -3px;
                "
              />
              <span class="gray-value">{{ getDistance(item) }}</span
              >&nbsp;mts
            </div>
          </div>
          <div style="flex: 1">
            <div class="metric-item">
              <img
                :src="require('@/assets/pump_orange.svg')"
                alt=""
                srcset=""
                style="width: 18px; height: 18px; margin-right: 8px"
              />
              <span class="gray-value">{{ (item.totalEnergy || 0).toFixed(1) }}</span
              >&nbsp;Joules
            </div>
            <div class="metric-item" style="margin-top: 8px">
              <img
                :src="require('@/assets/weight_orange.svg')"
                alt=""
                srcset=""
                style="
                  width: 24px;
                  height: 24px;
                  margin-right: 4px;
                  margin-left: -2px;
                "
              />
              <span class="gray-value">{{ (item.totalWeight || 0).toFixed(1) }}</span
              >&nbsp;kg
            </div>
          </div>
        </div>
      </div>
      <div class="mxp-container" style="flex-direction: row; margin-top: 16px">
        <div style="flex: 1">
          Active Kcal <br /><img
            :src="require('@/assets/calories_orange.svg')"
            alt=""
            srcset=""
            style="
              width: 24px;
              height: 24px;
              margin-right: 4px;
              margin-bottom: -4px;
            "
          /><span class="gray-value">{{ getCalories(item) }}</span>
        </div>
        <div style="flex: 1">
          Watch Kcals <br /><img
            :src="require('@/assets/DisconnectWatch.svg')"
            alt=""
            srcset=""
            style="
              width: 24px;
              height: 24px;
              margin-right: 4px;
              margin-bottom: -4px;
            "
          /><span class="gray-value">{{ getWatchCalories(item) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "result-details",
  props: {
    item: {
      type: Object,
      required: true,
      default: undefined,
    },
  },
  data() {
    return {
      selectedMetric: "MXP",
      chart: null,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Right Side",
            data: [],
            backgroundColor: "rgba(237, 112, 45, 0.8)",
            borderColor: "#ed702d",
            borderWidth: 1,
            barPercentage: 0.3,
            categoryPercentage: 0.8,
          },
          {
            label: "Left Side",
            data: [],
            backgroundColor: "rgba(58, 58, 58, 0.8)",
            borderColor: "#3a3a3a",
            borderWidth: 1,
            barPercentage: 0.3,
            categoryPercentage: 0.8,
          },
        ],
      },
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  watch: {
    item: {
      handler() {
        this.initChart();
      },
      deep: true,
    },
    selectedMetric: {
      handler() {
        this.initChart();
      },
    },
  },
  methods: {
    initChart() {
      if (!this.item?.historical && !this.item?.exercisesProgress && !this.item?.exercisesSaves) {
        return;
      }

      let dataR = [];
      let dataL = [];

      if ((this.item.restype === 'freestyle' || this.item.restype === 'live') && this.item.historical) {
        const groupBySide = this.item.historical.reduce((acc, curr) => {
          if (!acc[curr.side]) {
            acc[curr.side] = [];
          }
          acc[curr.side].push(curr);
          return acc;
        }, {});

        dataR = groupBySide.R?.map((h) =>
          this.selectedMetric === "MXP"
            ? h.mxp != undefined
              ? h.mxp
              : h.power / 1000
            : h.cals || 0
        ) || [];
        dataL = groupBySide.L?.map((h) =>
          this.selectedMetric === "MXP"
            ? h.mxp != undefined
              ? h.mxp
              : h.power / 1000
            : h.cals || 0
        ) || [];
      } else if (this.item.restype === 'coachedClass' && this.item.exercisesProgress) {
        const data = this.item.exercisesProgress.map((exercise) =>
          this.selectedMetric === "MXP"
            ? exercise.mxp || 0
            : exercise.calories || 0
        );
        
        dataR = data;
        dataL = [];
      } else if ((this.item.restype === 'preSet' || this.item.restype === 'byo') && this.item.exercisesSaves) {
        const data = this.item.exercisesSaves.map((h) =>
          this.selectedMetric === "MXP"
            ? h.mxp != undefined
              ? h.mxp
              : h.powerMadedExercise > 0
                ? h.powerMadedExercise / 1000
                : 0
            : h.calsBurnedExercise || 0
        );
        
        dataR = data;
        dataL = [];
      }

      const maxDataPoints = Math.max(dataR.length, dataL.length);

      // Update chart data
      this.chartData.labels = Array.from({ length: maxDataPoints }, (_, i) => i + 1);
      this.chartData.datasets[0].data = dataR;
      this.chartData.datasets[0].label = this.item.restype === 'freestyle' ? "Right Side" : "Exercises";
      this.chartData.datasets[1].data = dataL;

      const ctx = this.$refs.chart;
      if (ctx) {
        if (this.chart) {
          this.chart.destroy();
        }

        this.chart = new Chart(ctx, {
          type: "bar",
          data: this.chartData,
          options: {
            legend: { display: false },
            responsive: true,
            maintainAspectRatio: false,
            devicePixelRatio: 2,
            animation: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    fontSize: 10,
                    callback: function (val) {
                      return val;
                    },
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    autoSkip: false,
                    callback: function (val) {
                      return "";
                    },
                  },
                  gridLines: {
                    display: false,
                  },
                },
              ],
            },
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: false,
              },
            },
          },
        });
      }
    },
    getMXP(item) {
      const mxp = item.mxp
        ? item.mxp
        : item.totalPower > 0
        ? item.totalPower / 1000
        : 0;
      return mxp.toFixed(1);
    },
    getMXPBySide(item, side) {
      if (item && item.historical && item.historical.length > 0) {
        const mxp = item.historical.reduce((total, x) => {
          if (x.side === side) {
            return total + (x.mxp ? Number(x.mxp) : Number(x.power) / 1000);
          }
          return total;
        }, 0);
        return mxp.toFixed(1);
      }
      return 0;
    },
    getReps(item) {
      if (item && item.historical && item.historical.length > 0) {
        return item.historical.length;
      }
      return 0;
    },
    getRepsBySide(item, side) {
      if (item && item.historical && item.historical.length > 0) {
        return item.historical.filter((x) => x.side === side).length;
      }
      return 0;
    },
    getTotalTime(item) {
      switch (item.restype) {
        case "byo":
          return `${item.timeWorkout.minutes}:${item.timeWorkout.seconds}`;
        case "live":
          return `${item.timeWorkout.minutes}:${item.timeWorkout.seconds}`;
        case "preSet":
          return `${item.timeWorkout.minutes}:${item.timeWorkout.seconds}`;
        case "freestyle":
          return `${item.timeWorkout.minutes}:${item.timeWorkout.seconds}`;
        case "coachedClass":
          return item.totalTime;
        default:
          break;
      }
      return item.totalTime;
    },
    getDistance(item) {
      switch (item.restype) {
        case "byo":
          return item.totalDistance?.toFixed(1);
        case "live":
          return item.totalDistance?.toFixed(1);
        case "preSet":
          return item.totalDistance?.toFixed(1);
        case "freestyle":
          return item.distanceCord?.toFixed(1);
        case "coachedClass":
          return item.totalDistance?.toFixed(1);
        default:
          return 0;
      }
    },
    getCalories(item) {
      switch (item.restype) {
        case "byo":
          return item.cals?.toFixed(1);
        case "live":
          return item.cals?.toFixed(1);
        case "preSet":
          return item.cals?.toFixed(1);
        case "freestyle":
          return item.cals?.toFixed(1);
        case "coachedClass":
          return item.totalCalories?.toFixed(1);
        default:
          return 0;
      }
    },
    getWatchCalories(item) {
      switch (item.restype) {
        case "byo":
          return item.caloriesHr?.toFixed(1);
        case "live":
          return item.caloriesHr?.toFixed(1);
        case "preSet":
          return item.caloriesHr?.toFixed(1);
        case "freestyle":
          return item.calsHR?.toFixed(1);
        case "coachedClass":
          return item.caloriesHr?.toFixed(1);
        default:
          return 0;
      }
    },
  },
};
</script>

<style scoped>
.chart-wrapper {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  margin: 8px 0;
  overflow: hidden;
  width: 100%;
}

.chart-container {
  height: 240px;
  width: 100%;
  padding: 8px;
}

.chart-container canvas {
  height: 240px !important;
  width: 100% !important;
}

.chart-switch {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 16px;
  border-bottom: 1px solid #e4e4e4;
}

.switch-pill {
  width: 40px;
  height: 20px;
  padding: 0;
  border: 1px solid #e4e4e4;
  border-radius: 20px;
  background: #f5f5f5;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.switch-handle {
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  position: absolute;
  left: 2px;
  top: 1px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.switch-handle.active {
  left: 20px;
  background: #ed702d;
}

.switch-label {
  font-size: 12px;
  color: #3a3a3a;
  font-weight: normal;
  transition: all 0.2s ease;
}

.switch-label.active {
  font-weight: bold;
  color: #ed702d;
}

.metrics-wrapper {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  margin: 8px 0;
  overflow: hidden;
  width: 100%;
}

.workout-name {
  font-size: 16px;
  font-weight: bold;
  color: #3a3a3a;
}

.metrics-container {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.mxp-container {
  display: flex;
  flex-direction: column;
  border-width: 1px;
  background-color: #fff;
  border-color: #e4e4e4;
  border-style: solid;
  border-radius: 16px;
  padding: 16px;
  flex: 1;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.mxp-value {
  font-size: 24px;
  font-weight: bold;
  color: #ed702d;
}

.gray-value {
  font-size: 16px;
  color: #3a3a3a;
  font-weight: bold;
}

.mxp-label {
  font-size: 16px;
  color: #3a3a3a;
  font-weight: bold;
}

.metric-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style> 